import React, { useState, useEffect } from 'react';
import LimitMasterFlowPage from './LimitMasterFlowPage';
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../../../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import {
  get_value_limits_list
  // remove_gift_master
} from '../../../redux/slice';
//import FormData from 'form-data';

function LimitMasterFlow() {
  TabTitle('Gift Register - Entry Delegator Flows');

  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const {
    valueLimits_list,
    pagination,
    get_value_limits_listLoading,
    remove_entry_delegatorLoading
  } = useSelector((state) => state.admin);

  const [radiofilter, setRadiofilter] = useState(
    JSON?.parse(window.localStorage.getItem('set_Radiofilter')) === null
      ? ''
      : JSON?.parse(window.localStorage.getItem('set_Radiofilter'))
  );
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [searchRequest, setSearchRequest] = useState('');
  const [showDisablePopup, setShowDisablePopup] = useState(false);

  //console.log('searchRequest', searchRequest);
  //console.log(triggerFilter);
  console.log('valueLimits_list@@@@@@@@@@@@', valueLimits_list);

  useEffect(() => {
    handleGetAllEntryDelegatorsList();
  }, [page, pageSize]);
  useEffect(() => {
    if (triggerFilter) {
      if (page === 1) {
        handleGetAllEntryDelegatorsList();
      } else {
        setPage(1);
      }
    }
  }, [radiofilter, searchRequest]); //page,

  const handleGetAllEntryDelegatorsList = () => {
    let payload = {
      page,
      per_page: pageSize,
      status: radiofilter,
      search: searchRequest
    };
    dispatch(get_value_limits_list(payload));
  };

  /* const handleChange = (e) => {
    const value = { search: e.target.value, page, status: radiofilter };
    dispatch(searchvalues(value));
  };*/
  // const handleDeleteRequest = (record) => {
  //   let formdata = new FormData();
  //   console.log('recordQQQQQQQQQQ', record?.record);
  //   formdata.append('isActive', false);
  //   formdata.append('id', record?.record?.key);
  //   // dispatch(remove_gift_master(formdata)).then(function (response) {
  //   //   if (response) {
  //   //     handleGetAllEntryDelegatorsList();
  //   //   }
  //   // });
  // };
  return (
    <CustomLayout>
      <div style={{ marginTop: '50px' }}>
        <LimitMasterFlowPage
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          radiofilter={radiofilter}
          setRadiofilter={setRadiofilter}
          setTriggerFilter={setTriggerFilter}
          valueLimits_list={valueLimits_list}
          pagination={pagination}
          get_value_limits_listLoading={get_value_limits_listLoading}
          setSearchRequest={setSearchRequest}
          showDisablePopup={showDisablePopup}
          setShowDisablePopup={setShowDisablePopup}
          // handleDeleteRequest={handleDeleteRequest}
          remove_entry_delegatorLoading={remove_entry_delegatorLoading}
          handleGetAllEntryDelegatorsList={handleGetAllEntryDelegatorsList}
        />
      </div>
    </CustomLayout>
  );
}
export default LimitMasterFlow;
